<template>
  <div class="lobby-list">
    <Header 
      title="Últimas partidas" 
      subtitle="públicas"
    ></Header>
    <div class="container">
      <LobbiesTable :lobbies="lobbies"></LobbiesTable>

    </div>

  </div>
</template>

<script>
import Header from '@/components/Header'
import LobbiesTable from '@/components/LobbiesTable'
export default {
  name: 'LobbyList',
  metaInfo: {
    title: 'Lobbies competitivas'
  },
  data () {
    return {
      lobbies: []
    }
  },
  methods: {
    initialize() {
      this.$http
        .get('pages/latest_lobbies.json')
        .then(response => (this.lobbies = response.data))
      
    }
  },
  mounted () {
    this.initialize()
  },
  components: {
    Header,
    LobbiesTable
  }
}
</script>
